import type { PlantModel } from '../models/ultrasonic.models';

// TODO: Replace with real API data
export const DEFAULT_PLANTS: PlantModel[] = [
  {
    id: '8725724278068983',
    name: 'Schweinfurt',
    abbreviation: 'SWE',
    plantNumber: '0200',
    country: 'DE',
    region: 'Europe',
  },
  {
    id: '8725724278081779',
    name: 'Brasov',
    abbreviation: 'ISB',
    plantNumber: '0097',
    country: 'RO',
    region: 'Europe',
  },
];
